import { useShoppingCartsContext } from 'context/ShoppingCartsContext';
import { useEffect } from 'react';

import ShoppingCartDetailComponent from 'components/desktop/ShoppingCart/Detail/Index';
import LoadingSpinner from 'components/desktop/_general/Loading/LoadingSpinner';
import { ShoppingCart } from 'types/ShoppingCart/ShoppingCart';

const ShoppingCartNew = () => {
	const carts = useShoppingCartsContext();
	const cart: ShoppingCart.Type | undefined = carts.get('');

	useEffect(() => {
		if (cart !== undefined) return;
		carts.addNewCart();
	}, [cart]);

	return (
		<main className="container">
			{cart ? (
				<ShoppingCartDetailComponent
					cart={cart}
					editMode={true}
					refreshMenuPlanOrders={() => ''}
				/>
			) : (
				<LoadingSpinner style={{ marginTop: '80px' }} />
			)}
		</main>
	);
};

export default ShoppingCartNew;
